var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayforward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.996 14.3217C2.976 15.1057 1.5 14.3787 1.5 13.0927V2.90473C1.5 1.61873 2.976 0.891728 3.996 1.67573L10.22 6.86773C10.3857 7.00597 10.519 7.17893 10.6104 7.37436C10.7019 7.5698 10.7493 7.78295 10.7493 7.99873C10.7493 8.21451 10.7019 8.42765 10.6104 8.62309C10.519 8.81853 10.3857 8.99148 10.22 9.12973L3.996 14.3217Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.246 14.3217C12.226 15.1057 10.75 14.3787 10.75 13.0927V2.90473C10.75 1.61873 12.226 0.891728 13.246 1.67573L19.47 6.86773C19.6357 7.00597 19.769 7.17893 19.8604 7.37436C19.9519 7.5698 19.9993 7.78295 19.9993 7.99873C19.9993 8.21451 19.9519 8.42765 19.8604 8.62309C19.769 8.81853 19.6357 8.99148 19.47 9.12973L13.246 14.3217Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayforward);
export default __webpack_public_path__ + "static/media/playforward.882546b196f7ed99e40c9e3bfcf2da5d.svg";
export { ForwardRef as ReactComponent };